import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import { Modules } from "../../../constants/Module";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import moment from "moment";
import { withTranslation } from "react-i18next";
function Milestone({ item, t }) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {ucFirst(Modules.MILESTONE)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name.old : item?.payload?.name}){" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        by
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
            {typeof item?.payload?.currentStatus === "object" &&
            item?.payload?.currentStatus?.old &&
            item?.payload?.currentStatus?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Status')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.currentStatus?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.currentStatus?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.description === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Description')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.description?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.description?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {typeof item?.payload?.output === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Output')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.output?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.output?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {typeof item?.payload?.weight === "object" && 
          item?.payload?.weight.new >= 0 && item?.payload?.weight?.old >= 0 && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Weight')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.weight?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.weight?.new}</span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.estimatedStartDate &&
            item?.payload?.estimatedStartDate?.old &&
            item?.payload?.estimatedStartDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Start Date')}:</strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.estimatedStartDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {moment(item?.payload?.estimatedStartDate?.new).format("Do MMMM, YYYY")}
                    </span>
                  </div>
                </div>
              </div>
            )}
          {item?.payload?.estimatedEndDate &&
            item?.payload?.estimatedEndDate?.old &&
            item?.payload?.estimatedEndDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('End Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.estimatedEndDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{moment(item?.payload?.estimatedEndDate?.new).format("Do MMMM, YYYY")}</span>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(Milestone);